import gql from 'graphql-tag';

export const EXTRACT_VIDEO_FROM_ID = gql`
  query ExtractVideoFromId($videoId: String!) {
    extractVideoFromId(videoId: $videoId) {
      video {
        id
        picture
        source
        title
        videoSource
      }
      errors
    }
  }
`;
